import styled, { css } from 'styled-components'

import { fontType, toRem, transition } from '../../styles/functions'

interface ITabButtonProps {
	isActive: boolean
	disabled?: boolean
}

export const TabWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
`

export const TabHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 32px;
	border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
	padding: 0 8px;
`

export const TabButton = styled.button<ITabButtonProps>`
	position: relative;
	background: transparent;
	border: none;
	padding: 16px 4px;
	font-size: ${toRem(14)};
	cursor: pointer;
	${fontType(1)}
	${transition()}

	color: ${({ theme, isActive }) =>
		isActive ? theme.colors.blue : theme.colors.darkGrey};

	&::after {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		bottom: -1px;
		height: 2px;
		background: ${({ theme }) => theme.colors.blue};
		border-radius: 2px;
		${transition()}

		${({ isActive }) =>
			isActive
				? css`
						opacity: 1;
						transform: scaleX(1);
				  `
				: css`
						opacity: 0;
						transform: scaleX(0);
				  `}
	}

	&:hover {
		color: ${({ theme, isActive, disabled }) =>
			disabled || isActive ? undefined : theme.colors.blue};
	}

	&[disabled] {
		cursor: not-allowed;
		color: ${({ theme }) => theme.colors.grey};
	}
`

export const TabContent = styled.div`
	width: 100%;
	padding-top: 24px;
`
